import SmoothScroll from "smooth-scroll";

const hamburger = document.querySelector('.navbar__hamburger');
const navWrapper = document.querySelector('.navbar__navWrapper');

hamburger.addEventListener('click', function () {
    if (navWrapper.style.maxHeight) {
        closeNav();
    } else {
        openNav();
    }
});

function openNav() {
    navWrapper.style.maxHeight = navWrapper.scrollHeight + 'px';
    hamburger.classList.add('is-active');
}

function closeNav() {
    navWrapper.style.maxHeight = null;
    hamburger.classList.remove('is-active');
}


var scroll = new SmoothScroll('a[href*="#"]', {
    easing: 'easeOutCubic',
    speed: 800,
    speedAsDuration: true,
    offset: 42
});

document.addEventListener('scrollStart', function() {
    document.body.classList.add('body_is-scrolling');
})

document.addEventListener('scrollStop', function () {
    document.body.classList.remove('body_is-scrolling');
})